import React from "react";
import ZCard from "../../Card/Index";
import { Col, Flex, Row, Spin, Table, Typography } from "antd";
import CustomTypography from "../../common/CustomTypography";
import { useSelector } from "react-redux";
import styles from "./upiTxnAnalysis.module.scss";
import { CurrencyFormatWithDecimal } from "../../../helper/CurrencyFormate";
import { CURRENCY } from "../../../utils/ConstantData";
import dayjs from "dayjs";
import CustomAmountText from "../../common/CustomAmountText";

const UPITxnAnalysisPage = () => {
    const { upiTxnAnalysisDetails, upiTxnAnalysisLoading: loading, upiTxnAnalysisError: error } = useSelector(({ upiTxnAnalysis }) => upiTxnAnalysis);

    const SectionHeader = ({ title }) => {
        return (
            <Flex className="pb-8">
                <CustomTypography style={{ fontWeight: 700, fontSize: "14px", lineHeight: "22px", color: "#000000E0", fontFamily: "Satoshi" }}>{title}</CustomTypography>
            </Flex>
        );
    }

    const commonColumns = [
        {
            key: "amount",
            dataIndex: "amount",
            title: "Total txn amount (₹)",
            render: (value) => (
                <Typography.Text {...(value < 0 ? { type: "danger" } : {})}>{CurrencyFormatWithDecimal(value, null, CURRENCY)}</Typography.Text>
            )
            // className: styles.tdTextStyle
        },
        {
            key: "amountPt",
            dataIndex: "amountPt",
            title: "%Total UPI txn amount",
            // className: styles.tdTextStyle
        },
        {
            key: "transactionCount",
            dataIndex: "transactionCount",
            title: "Total txn count",
            // className: styles.tdTextStyle
        },
        {
            key: "transactionPercentage",
            dataIndex: "transactionPercentage",
            title: "%Total UPI txn count",
            // className: styles.tdTextStyle
        },
    ]

    const commonSummaryColumns = [
        {
            key: "amount",
            dataIndex: "amount",
            title: "Total txn amount (₹)",
            render: (value) => (
                <CustomAmountText shouldDisplayCurrency={true} value={value} />
            )
            // className: styles.tdTextStyle
        },
        {
            key: "amountPt",
            dataIndex: "amountPt",
            title: "%Total UPI txn amount",
            // className: styles.tdTextStyle
        },
        {
            title: 'Avg txn amount (₹)',
            dataIndex: 'avgAmount',
            key: 'avgAmount',
            className: `${styles.tdTextStyle}`,
            width: "20%",
            responsive: ['lg'],
            render: (value) => (
                <Typography.Text {...(value < 0 ? { type: "danger" } : {})}>{CurrencyFormatWithDecimal(value, null, CURRENCY)}</Typography.Text>
            )

        },
        {
            key: "transactionCount",
            dataIndex: "transactionCount",
            title: "Total txn count",
            // className: styles.tdTextStyle
        },
        {
            key: "transactionPercentage",
            dataIndex: "transactionPercentage",
            title: "%Total UPI txn count",
            // className: styles.tdTextStyle
        },
    ]

    const summaryColumns = [
        {
            key: "txnType",
            dataIndex: "txnType",
            title: "Transaction Type",
            className: `${styles.colHighlighted}`
        },
        {
            key: "startDate",
            dataIndex: "startDate",
            title: "First txn date",
            render: (value) => (
                dayjs(value).format('DD/MM/YYYY')
            ),
            // className: styles.tdTextStyle
        },
        {
            key: "endDate",
            dataIndex: "endDate",
            title: "Last txn date",
            render: (value) => (
                dayjs(value).format('DD/MM/YYYY')
            ),
            // className: styles.tdTextStyle
        },
        ...commonSummaryColumns,
    ];

    const inflowCounterpartyDistributionColumns = [
        {
            key: "counterparty",
            dataIndex: "counterparty",
            title: "Counterparty",
            className: `${styles.colHighlighted}`
        },
        ...commonColumns,
    ];

    const outflowCounterpartyDistributionColumns = [
        ...inflowCounterpartyDistributionColumns,
    ];

    const inflowModeDistributionColumns = [
        {
            key: "paymentType",
            dataIndex: "paymentType",
            title: "Payment type",
            className: `${styles.colHighlighted}`
        },
        ...commonColumns,
    ];

    const outflowModeDistributionColumns = [
        ...inflowModeDistributionColumns,
    ];

    const inflowAppDistributionColumns = [
        {
            key: "upiApp",
            dataIndex: "upiApp",
            title: "UPI App",
            className: `${styles.colHighlighted}`
        },
        ...commonColumns,
    ];

    const outflowAppDistributionColumns = [
        ...inflowAppDistributionColumns,
    ];

    const inflowColumns = [
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            className: `${styles.tdTextStyle}`,
            width: "20%",
            responsive: ['lg']
        },
        {
            title: 'Total txn amount (₹)',
            dataIndex: 'amount',
            key: 'amount',
            className: `${styles.tdTextStyle}`,
            width: "20%",
            responsive: ['lg'],
            render: (value) => (
                <Typography.Text {...(value < 0 ? { type: "danger" } : {})}>{CurrencyFormatWithDecimal(value, null, CURRENCY)}</Typography.Text>
            )

        },
        {
            title: '%Total UPI txn amount',
            dataIndex: 'exposure',
            key: 'exposure',
            render: (text) => `${text}%`,
            className: `${styles.tdTextStyle}`,
            width: "20%",
            responsive: ['lg']
        },
        {
            title: 'Avg txn amount (₹)',
            dataIndex: 'avgAmount',
            key: 'avgAmount',
            className: `${styles.tdTextStyle}`,
            width: "20%",
            responsive: ['lg'],
            render: (value) => (
                <Typography.Text {...(value < 0 ? { type: "danger" } : {})}>{CurrencyFormatWithDecimal(value, null, CURRENCY)}</Typography.Text>
            )

        },
        {
            title: 'Transaction count',
            key: 'transactionCount',
            dataIndex: 'transactionCount',
            className: `${styles.tdTextStyle}`,
            width: "20%",
            responsive: ['lg']
        },
    ];


    const expandedInflowColumns = [
        ...inflowColumns,
    ];

    const outflowColumns = [
        ...inflowColumns,
    ];

    const expandedOutflowColumns = [
        ...outflowColumns,
    ];

    if (loading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px" }}>
                <Spin size="large" />
            </div>
        )
    }

    if (error) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px", flexDirection: "column" }}>
                <CustomTypography style={{ fontSize: "16px", fontWeight: 500, lineHeight: "24px", color: "#000000E0", fontFamily: "Satoshi" }}>Error fetching data</CustomTypography>
                <CustomTypography type={"paragraph"} style={{ fontSize: "10px", fontWeight: 300, lineHeight: "16px", color: "#000000E0", fontFamily: "Satoshi" }}>{error}</CustomTypography>
            </div>
        )
    }

    const getLastRowClassName = (data, index) => {
        return index === data.length - 1 ? styles.darkTableRowText : styles.tdTextStyle;
    }

    return (
        <>
            <div>
                <Row gutter={[16, 16]} className="pt-8">
                    <Col className='w-100' span={24} >
                        <ZCard>
                            <SectionHeader title="UPI Transaction Analysis" />
                            <Flex>
                                <Table pagination={false} columns={summaryColumns} dataSource={upiTxnAnalysisDetails?.summary || []} className='w-100' rowClassName={(record, index) => { return styles.tdTextStyle }} />
                            </Flex>
                        </ZCard>
                    </Col>
                </Row>
                <Row gutter={[16, 16]} className="pt-16">
                    <Col className='w-100' span={12}>
                        <ZCard>
                            <SectionHeader title={`Credit Transaction - Top ${upiTxnAnalysisDetails?.inflowCounterpartyDistribution?.length - 1 || null} Counterparty`} />
                            <Flex>
                                <Table pagination={false} columns={inflowCounterpartyDistributionColumns} dataSource={upiTxnAnalysisDetails?.inflowCounterpartyDistribution || []} className='w-100' rowClassName={(record, index) => getLastRowClassName(upiTxnAnalysisDetails?.inflowCounterpartyDistribution, index)} />
                            </Flex>
                        </ZCard>
                    </Col>
                    <Col className='w-100' span={12} >
                        <ZCard>
                            <SectionHeader title={`Debit Transaction - Top ${upiTxnAnalysisDetails?.outflowCounterpartyDistribution?.length - 1 || null} Counterparty`} />
                            <Flex>
                                <Table pagination={false} columns={outflowCounterpartyDistributionColumns} dataSource={upiTxnAnalysisDetails?.outflowCounterpartyDistribution || []} rowClassName={(record, index) => getLastRowClassName(upiTxnAnalysisDetails?.outflowCounterpartyDistribution, index)} className='w-100' />
                            </Flex>
                        </ZCard>
                    </Col>
                </Row>
                <Row gutter={[16, 16]} className="pt-16">
                    <Col className='w-100' span={12}>
                        <ZCard>
                            <SectionHeader title={`Credit Transaction - P2P vs P2M Distribution`} />
                            <Flex>
                                <Table pagination={false} columns={inflowModeDistributionColumns} dataSource={upiTxnAnalysisDetails?.inflowModeDistribution || []} rowClassName={(record, index) => getLastRowClassName(upiTxnAnalysisDetails?.inflowModeDistribution, index)} className='w-100' />
                            </Flex>
                        </ZCard>
                    </Col>
                    <Col className='w-100' span={12}>
                        <ZCard>
                            <SectionHeader title={`Debit Transaction - P2P vs P2M Distribution`} />
                            <Flex>
                                <Table pagination={false} columns={outflowModeDistributionColumns} dataSource={upiTxnAnalysisDetails?.outflowModeDistribution || []} rowClassName={(record, index) => getLastRowClassName(upiTxnAnalysisDetails?.outflowModeDistribution, index)} className='w-100' />
                            </Flex>
                        </ZCard>
                    </Col>
                </Row>
                <Row gutter={[16, 16]} className="pt-16">
                    <Col className='w-100' span={12}>
                        <ZCard>
                            <SectionHeader title={`Credit Transaction - UPI Apps distribution`} />
                            <Flex>
                                <Table pagination={false} columns={inflowAppDistributionColumns} dataSource={upiTxnAnalysisDetails?.inflowAppDistribution || null} rowClassName={(record, index) => getLastRowClassName(upiTxnAnalysisDetails?.inflowAppDistribution, index)} className='w-100' />
                            </Flex>
                        </ZCard>
                    </Col>
                    <Col className='w-100' span={12}>
                        <ZCard>
                            <SectionHeader title={`Debit Transaction - UPI Apps distribution`} />
                            <Flex>
                                <Table pagination={false} columns={outflowAppDistributionColumns} dataSource={upiTxnAnalysisDetails?.outflowAppDistribution || []} rowClassName={(record, index) => getLastRowClassName(upiTxnAnalysisDetails?.outflowAppDistribution, index)} className='w-100' />
                            </Flex>
                        </ZCard>
                    </Col>
                </Row>
                <Row gutter={[16, 16]} className="pt-16">
                    <Col className='w-100' span={12}>
                        <ZCard>
                            <SectionHeader title={`Inflow Categories`} />
                            <Flex>
                                <TableWithExpandableRows columns={inflowColumns} data={upiTxnAnalysisDetails?.inflow[0].data || []} expandedColumns={expandedInflowColumns} className='w-100' />
                            </Flex>
                        </ZCard>
                    </Col>
                    <Col className='w-100' span={12}>
                        <ZCard>
                            <SectionHeader title={`Outflow Categories`} />
                            <Flex>
                                <TableWithExpandableRows columns={outflowColumns} data={upiTxnAnalysisDetails?.outflow[0].data || []} expandedColumns={expandedOutflowColumns} className='w-100' />
                            </Flex>
                        </ZCard>
                    </Col>
                </Row>
            </div>
        </>
    );
};

const TableWithExpandableRows = ({ columns = [], data = [], expandedColumns = [] }) => (
    <Table
        columns={columns}
        dataSource={data}
        expandable={{
            expandedRowRender: (record) => {
                return <Table
                    showHeader={false}
                    columns={expandedColumns}
                    dataSource={record.subCategories}
                    pagination={false}
                />
            },
            rowExpandable: (record) => record.subCategories.length > 0,
        }}
        pagination={false}
    />
);

export default UPITxnAnalysisPage;
